import { ApiPath } from 'common/enums/http/api-path';
import type { ResponseWithPagination } from 'common/types';
import type { ServiceAllUpdates } from 'models/service-all-updates';
import { http } from 'services/http';

export const getServiceAllUpdatesApi = () =>
  http.get<ResponseWithPagination<ServiceAllUpdates>>(
    ApiPath.SERVICE_ALL_UPDATES
  );
